import { Component } from '@angular/core';

@Component({
  selector: 'app-notfound',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {}
